import { MessageType } from "shared/enums/MessageType";
import { MessageGroupProps, MessageProps } from "./type";
import classNames from "classnames";
import Icon from "assets/icons";

export default function MessageGroup({ children, className }: MessageGroupProps) {
  return <div className={classNames("messageGroup", className)}>{children}</div>;
}

function BaseMessage({
  text,
  icon,
  hideIcon,
  renderAsHtml = false,
  isItalic,
  className,
  type
}: MessageProps & { type: MessageType }) {
  let displayIcon: React.ReactNode = icon;

  if (!hideIcon && !icon) {
    switch (type) {
      case MessageType.SUCCESS:
        displayIcon = <Icon.CheckCircle />;
        break;
      default:
        displayIcon = <Icon.InfoCircle />;
        break;
    }
  }

  return (
    <span
      className={classNames(
        "message",
        `message--${type}`,
        {
          "message--italic": isItalic
        },
        className
      )}>
      {displayIcon && <span className="message_icon">{displayIcon}</span>}
      <span className="message_text">{renderAsHtml ? <span dangerouslySetInnerHTML={{ __html: text }} /> : text}</span>
    </span>
  );
}

function MessageError(props: MessageProps) {
  return <BaseMessage {...props} type={MessageType.ERROR} />;
}
function MessageWarning(props: MessageProps) {
  return <BaseMessage {...props} type={MessageType.WARNING} />;
}
function MessageSuccess(props: MessageProps) {
  return <BaseMessage {...props} type={MessageType.SUCCESS} />;
}
function MessageInfo(props: MessageProps) {
  return <BaseMessage {...props} type={MessageType.INFO} />;
}
function MessageMuted(props: MessageProps) {
  return <BaseMessage {...props} type={MessageType.MUTED} />;
}
function MessageRegular(props: MessageProps) {
  return <BaseMessage {...props} type={MessageType.REGULAR} />;
}

export const Message = {
  Error: MessageError,
  Warning: MessageWarning,
  Success: MessageSuccess,
  Info: MessageInfo,
  Muted: MessageMuted,
  Regular: MessageRegular
};
